export const questions = `
1. Walk me through a basic merger model.
2. What's the difference between a merger and an acquisition?
3. Why would a company want to acquire another company?
4. Why would an acquisition be dilutive?
5. Is there a rule of thumb for calculating whether an acquisition will be accretive or dilutive?
6. A company with a higher P/E acquires one with a lower P/E – is this accretive or dilutive?
7. What is the rule of thumb for assessing whether an M&A deal will be accretive or dilutive?
8. What are the complete effects of an acquisition?
9. If a company were capable of paying 100% in cash for another company, why would it choose NOT to do so?
10. Why would a strategic acquirer typically be willing to pay more for a company than a private equity firm would?
11. Why do Goodwill & Other Intangibles get created in an acquisition?
12. What is the difference between Goodwill and Other Intangible Assets?
13. Is there anything else "intangible" besides Goodwill & Other Intangibles that could also impact the combined company?
14. What are synergies, and can you provide a few examples?
15. How are synergies used in merger models?
16. Are revenue or cost synergies more important?
17. All else being equal, which method would a company prefer to use when acquiring another company – cash, stock, or debt?
18. How much debt could a company issue in a merger or acquisition?
19. How do you determine the Purchase Price for the target company in an acquisition?
20. Let's say a company overpays for another company – what typically happens afterwards and can you give any recent examples?
21. A buyer pays $100 million for the seller in an all‐stock deal, but a day later the market decides it's only worth $50 million. What happens?
22. Why do most mergers and acquisitions fail?
23. What role does a merger model play in deal negotiations?
24. What types of sensitivities would you look at in a merger model? What variables would you look at?
`;